/* eslint-disable */

import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import Banner from "Components/Home/Banner/Banner";
import About from "Components/Home/About/About";
import ProjectCount from "Components/Home/ProjectCount/ProjectCount";
import Sponsors from "Components/Home/Sponsors/Sponsors";

const Home = () => {
  return (
    <>
      <Header moduleName={"home"} />

      <Banner />

      <About />

      <ProjectCount />

      <Sponsors />

      <Footer />
    </>
  );
};

export default Home;
